import { combineReducers } from 'redux';

// Importando meus reducers
import auth from './auth/reducer';
import user from './user/reducer';
import dash from './dash/reducer';

export default combineReducers({ auth, user, dash });
